import { RootState } from '@/domain/store';

export const selectEarlyFeatureCode = (state: RootState) => {
  return state.earlyFeature.code;
};
